import styled from 'styled-components';
import breakpoints from '../../styles/breakpoints';
import colors from '../../styles/colors';

export const LogoWrapper = styled.div`
    width: 12%;
    height: 100%;
    cursor: pointer;

    ${breakpoints.maxMd} {
        width: 18%;
    }
`;

export const BannerWrapper = styled.div`
    top: 0;
    left: 0;
    width: 100%;
    height: 6vw;
    display: flex;
    overflow: hidden;
    position: absolute;
    justify-content: space-between;
    transition: all 300ms ease-in-out;
    background-color: ${colors.primary};

    @media only screen and (min-width: 1500px) {
        height: 100px;
    }

    ${breakpoints.maxMd} {
        height: 9vw;
    }

    ${breakpoints.maxSm} {
        height: 11vw;
    }

    .wirewax-name-logo {
        height: 100%;
        width: 100%;
    }
`;

export const TextWrapper = styled.p`
    width: 513px;
    font-size: 23px;
    font-style: normal;
    text-align: center;
    font-weight: normal;
    line-height: normal;
    font-family: Poppins;
    font-stretch: normal;
    letter-spacing: normal;
    color: ${colors.heavyMetal};

    ${breakpoints.maxLg} {
        width: 400px;
        font-size: 18px;
    }

    @media only screen and (max-width: 880px) {
        width: 300px;
        font-size: 13px;
    }

    @media only screen and (max-width: 700px) {
        display: none;
    }
`;

export const ContentWrapper = styled.div`
    display: flex;
    margin-right: 2%;
    align-items: center;
`;
